export default __webpack_public_path__ + "static/anchor-01b-dont-33bbae9fdbccbb11bb86aafc68e65382.png";